define.alias("shared/components/shared/ui/list-uploaded-items", "calendar/components/shared/ui/list-uploaded-items");